import React from 'react';
import { Link } from 'react-router-dom';

import BotonGuardar from './BotonGuardar.jsx';
import BotonCancelar from './BotonCancelar.jsx';

import ProcessManager from '../../../Common/Managers/ProcessManager';

const HeaderButtons = (props) => {
    return (
        <div className="row bottom-separator-xs">
            <div className="col-md-3">
                <BotonGuardar functions={props.functions}
                    guardarConfiguracion={props.guardarConfiguracion}
                    configuracion={props.configuracion}/>               
            </div>
            <div className="col-md-3">
                <BotonCancelar 
                cleanStorage={props.cleanStorage}
                functions={props.functions} />
            </div>
        </div>
    );
}  

export default HeaderButtons

 